import { Component } from '@angular/core';

@Component({
  selector: 'num-linked-badge',
  templateUrl: './linked-badge.component.html',
  styleUrls: ['./linked-badge.component.scss'],
})
export class LinkedBadgeComponent {}
